import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import styles from "assets/jss/elite-feats-cms/components/cardStyle";

const useStyles = makeStyles(styles);

interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "color"> {
  className?: string;
  plain?: boolean;
  variant?: string;
  profile?: boolean;
  blog?: boolean;
  raised?: boolean;
  background?: boolean;
  pricing?: boolean;
  testimonial?: boolean;
  color?: "primary" | "info" | "success" | "warning" | "danger" | "rose";
  product?: boolean;
  chart?: boolean;
  login?: boolean;
  children?: React.ReactNode;
}

export default function Card(props: CardProps): React.ReactElement {
  const classes = useStyles();
  const {
    className,
    children,
    plain,
    profile,
    blog,
    raised,
    background,
    pricing,
    color,
    product,
    testimonial,
    chart,
    login,
    ...rest
  } = props;
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardProfile]: profile || testimonial,
    [classes.cardBlog]: blog,
    [classes.cardRaised]: raised,
    [classes.cardBackground]: background,
    [classes.cardPricingColor]:
      (pricing && color !== undefined) || (pricing && background !== undefined),
    [classes[color as string]]: color,
    [classes.cardPricing]: pricing,
    [classes.cardProduct]: product,
    [classes.cardChart]: chart,
    [classes.cardLogin]: login,
    [className as string]: className !== undefined,
  });

  return (
    <div className={cardClasses} {...rest}>
      {" "}
      {children}
    </div>
  );
}
